<template>
  
  <div class="con_content">
       <div class="container">
            <div class="container_top h_48">账户设置</div>
           

           <Header class="my_title txt_l">
               <span class="my_titleL">
                    <Icon class="fw_900 " type="ios-list" size='30'/>     
                    账户设置
               </span>
            </Header>
            <!-- table组件 -->
            <div class="my_table   my_body  padlr20">
               
            </div>

        </div>
        
    </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    
    export default {
        
        name:'system',
        data () {
            return {
                // vuex
                token:'',  
            }    
        },
       
        
        
       
        methods: {
           load(){
               let that = this;
               
                

            //    that.$ajax({
                
            //         method:'get',
            //         url: 'admin/service/statistics/index',
            //         data: {},
            //         
            //     }).then(res => {
                       
            //             that.list = res.data.data;
                       

                       
                  
            //     }).catch(err=>{
            //         console.log(err)
            //     });
             
           },
            
           
            
        },
        mounted: function(){
           var that = this;
           that.token = that.$store.state.token;
           that.guid = that.$store.state.guid;
           that.load();
           
            
        }
    }
</script>
<style scoped>
  
  
    
</style>




